// All CMS UI copy (MVP is Thai-only; keeping it in one module makes a later i18n split cheap).
import { SITES_DOMAIN } from '@edgepage/block-contracts/platform-domains';

export const th = {
  app: {
    name: 'EdgePage',
    loading: 'กำลังโหลด…',
    notFound: 'ไม่พบหน้าที่คุณต้องการ',
    backHome: 'กลับหน้าหลัก',
    tagline: 'จัดการเว็บไซต์',
    // u16 D3: the sidebar shell.
    openMenu: 'เปิดเมนู',
    closeMenu: 'ปิดเมนู',
    mainNav: 'เมนูหลัก',
    sections: {
      main: 'หลัก',
      site: 'เว็บไซต์นี้',
      account: 'บัญชี',
      help: 'ช่วยเหลือ',
      admin: 'ผู้ดูแลระบบ',
    },
    staff: { platform_admin: 'ผู้ดูแลแพลตฟอร์ม', platform_support: 'ทีมซัพพอร์ต' },
  },
  // u28: in-app feedback (problem reports and feature requests).
  feedback: {
    open: 'แจ้งปัญหา / เสนอฟีเจอร์',
    mine: 'รายการที่ฉันแจ้ง',
    title: 'แจ้งปัญหาหรือเสนอฟีเจอร์',
    kindLegend: 'เรื่องที่อยากบอกเรา',
    kinds: {
      problem: ['ปัญหาการใช้งาน', 'มีบางอย่างไม่ทำงานหรือใช้ยาก'],
      feature: ['ขอฟีเจอร์', 'อยากให้ระบบทำอะไรได้เพิ่ม'],
      other: ['อื่นๆ', 'คำถามหรือข้อเสนอแนะทั่วไป'],
    },
    subject: 'หัวข้อ',
    subjectHint: 'สั้น ๆ เช่น "กดบันทึกหน้าแล้วไม่มีอะไรเกิดขึ้น"',
    body: 'รายละเอียด',
    bodyHint: 'เล่าสิ่งที่เกิดขึ้น หรือสิ่งที่อยากให้มี',
    steps: 'ทำอะไรอยู่ตอนเกิดปัญหา (ไม่บังคับ)',
    stepsHint: 'เช่น เปิดหน้าแรก → กดเพิ่มส่วน → เลือกคำถามที่พบบ่อย',
    count: (n: number, max: number) => `${n}/${max}`,
    screenshot: 'แนบภาพหน้าจอ (ไม่บังคับ, 1 รูป)',
    chooseImage: 'เลือกรูป',
    removeImage: 'เอารูปออก',
    imageWarning:
      'ตรวจดูก่อนส่ง: ภาพต้องไม่มีข้อมูลของลูกค้า เช่น ชื่อ เบอร์โทร หรืออีเมล ถ้ามีให้ครอปหรือปิดส่วนนั้นก่อน',
    imagePreview: 'ภาพหน้าจอที่จะส่ง',
    preparingImage: 'กำลังย่อรูป…',
    imageFailed: 'ใช้รูปนี้ไม่ได้ ลองเลือกรูป PNG หรือ JPEG อื่น',
    attached: 'ข้อมูลที่แนบให้อัตโนมัติ',
    attachedHelp: 'ช่วยให้ทีมตรวจสอบได้เร็วขึ้น ไม่มีเนื้อหาในหน้าหรือข้อมูลลูกค้าของคุณ',
    ctx: {
      screen: 'หน้าจอ',
      site: 'เว็บไซต์',
      noSite: '— (ไม่ได้อยู่ในเว็บไซต์ใด)',
      version: 'เวอร์ชันระบบ',
      browser: 'เบราว์เซอร์และระบบปฏิบัติการ (แบบคร่าว ๆ)',
    },
    send: 'ส่ง',
    sentTitle: 'ได้รับเรื่องแล้ว ขอบคุณครับ',
    sentHelp:
      'ทีมงานจะตรวจสอบและตอบกลับในหน้า "รายการที่ฉันแจ้ง" เมื่อมีความคืบหน้าจะมีอีเมลแจ้งให้ทราบ',
    viewIt: 'ดูรายการนี้',
    close: 'ปิด',
    empty: 'ยังไม่มีรายการที่แจ้ง',
    emptyHelp: 'เจอปัญหาหรืออยากได้อะไรเพิ่ม กด "แจ้งปัญหา / เสนอฟีเจอร์" ได้ทุกหน้า',
    statuses: {
      received: 'ได้รับแล้ว',
      reviewing: 'กำลังตรวจสอบ',
      planned: 'วางแผนแล้ว',
      in_progress: 'กำลังทำ',
      done: 'เสร็จแล้ว',
      declined: 'ไม่ทำในตอนนี้',
      duplicate: 'ซ้ำกับรายการอื่น',
    },
    sentAt: (d: string) => `แจ้งเมื่อ ${d}`,
    you: 'คุณ',
    team: 'ทีมงาน EdgePage',
    note: 'โน้ตภายใน (ผู้แจ้งไม่เห็น)',
    reply: 'ส่งข้อความเพิ่ม',
    replyLabel: 'ข้อความ',
    closedNote: 'รายการนี้ปิดแล้ว หากยังพบปัญหา กรุณาแจ้งเป็นรายการใหม่',
    duplicateOf: (id: string) => `ซ้ำกับรายการ #${id}`,
    back: '← รายการที่ฉันแจ้ง',
  },
  common: {
    email: 'อีเมล',
    password: 'รหัสผ่าน',
    passwordHint: 'อย่างน้อย 10 ตัวอักษร',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    remove: 'ลบ',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    download: 'ดาวน์โหลด',
    unlimited: 'ไม่จำกัด',
  },
  auth: {
    loginTitle: 'เข้าสู่ระบบ',
    loginSubmit: 'เข้าสู่ระบบ',
    challenge: 'มีการใส่รหัสผ่านผิดหลายครั้ง กรุณายืนยันว่าไม่ใช่บอทก่อนเข้าสู่ระบบ',
    challengeFrame: 'ยืนยันว่าไม่ใช่บอท',
    noAccount: 'ยังไม่มีบัญชี?',
    toRegister: 'สมัครสมาชิก',
    forgot: 'ลืมรหัสผ่าน?',
    registerTitle: 'สร้างบัญชี EdgePage',
    registerSubmit: 'สมัครสมาชิก',
    haveAccount: 'มีบัญชีอยู่แล้ว?',
    toLogin: 'เข้าสู่ระบบ',
    mfaTitle: 'ยืนยันตัวตนสองขั้นตอน',
    mfaHelp: 'กรอกรหัส 6 หลักจากแอปยืนยันตัวตนของคุณ',
    mfaCode: 'รหัสยืนยัน',
    useRecovery: 'ใช้รหัสกู้คืนแทน',
    useTotp: 'ใช้รหัสจากแอปแทน',
    recoveryCode: 'รหัสกู้คืน',
    verify: 'ยืนยัน',
    verifyingEmail: 'กำลังยืนยันอีเมล…',
    emailVerified: 'ยืนยันอีเมลเรียบร้อยแล้ว',
    forgotTitle: 'ลืมรหัสผ่าน',
    forgotSubmit: 'ส่งลิงก์ตั้งรหัสผ่านใหม่',
    forgotSent:
      'หากอีเมลนี้มีบัญชีอยู่ เราได้ส่งลิงก์ตั้งรหัสผ่านใหม่ให้แล้ว กรุณาตรวจสอบกล่องจดหมาย',
    resetTitle: 'ตั้งรหัสผ่านใหม่',
    newPassword: 'รหัสผ่านใหม่',
    resetSubmit: 'บันทึกรหัสผ่านใหม่',
    resetDone: 'ตั้งรหัสผ่านใหม่เรียบร้อยแล้ว กรุณาเข้าสู่ระบบอีกครั้ง',
    logout: 'ออกจากระบบ',
    missingToken: 'ลิงก์ไม่สมบูรณ์ กรุณาเปิดลิงก์จากอีเมลอีกครั้ง',
    recipient: {
      title: 'ยืนยันการรับแจ้งเตือนลูกค้าใหม่',
      help: 'เจ้าของเว็บไซต์เพิ่มอีเมลของคุณเป็นผู้รับแจ้งเตือนเมื่อมีลูกค้าฝากข้อมูล กดยืนยันหากคุณต้องการรับ หากไม่ต้องการ ปิดหน้านี้ได้เลย',
      confirm: 'ยืนยันรับแจ้งเตือน',
      done: (site: string) => `ยืนยันแล้ว คุณจะได้รับอีเมลแจ้งเตือนจากเว็บไซต์ ${site}`,
    },
  },
  dashboard: {
    title: 'เว็บไซต์ของฉัน',
    empty: 'ยังไม่มีเว็บไซต์',
    emptyHelp: 'เริ่มสร้างเว็บไซต์ธุรกิจของคุณได้ในไม่กี่นาที',
    create: 'สร้างเว็บไซต์',
    open: 'จัดการ',
    roles: { owner: 'เจ้าของ', editor: 'ผู้แก้ไข', support_viewer: 'ผู้ดูอย่างเดียว' },
    plans: { free: 'ฟรี', pro_monthly: 'PRO รายเดือน', pro_annual: 'PRO รายปี' },
    verifyEmailBanner: 'กรุณายืนยันอีเมลก่อนเผยแพร่เว็บไซต์',
    resend: 'ส่งอีเมลยืนยันอีกครั้ง',
    resent: 'ส่งอีเมลยืนยันแล้ว',
    continueWizard: 'สร้างเว็บต่อจากที่ค้างไว้',
  },
  site: {
    nav: {
      overview: 'ภาพรวม',
      pages: 'หน้าเว็บ',
      menus: 'เมนู',
      media: 'คลังรูป',
      settings: 'ตั้งค่า',
      versions: 'เวอร์ชัน',
      redirects: 'Redirects',
      integrations: 'เชื่อมต่อ',
      leads: 'ลูกค้า',
      analytics: 'สถิติ',
      billing: 'แพ็กเกจ',
      domains: 'โดเมน',
      team: 'ทีมงาน',
      // Sidebar: the set-and-forget pages sit under one "ตั้งค่า" group; its first item is the
      // site settings page itself.
      settingsGroup: 'ตั้งค่า',
      general: 'ทั่วไป',
      // u44 (settings IA): menu label = page heading.
      siteSettings: 'ตั้งค่าเว็บไซต์',
      publishing: 'การเผยแพร่',
      connections: 'การเชื่อมต่อ',
      billingFull: 'แพ็กเกจและการชำระเงิน',
    },
    pagesQuota: 'จำนวนหน้า',
    mediaQuota: 'จำนวนรูป',
    storageQuota: 'พื้นที่รูป (MB)',
    switcher: 'เลือกเว็บไซต์',
    usageTitle: 'แพ็กเกจและการใช้งานเดือนนี้',
    leads: 'Lead ที่ดูได้',
    emails: 'อีเมลแจ้งเตือน',
    upgrade: 'อัปเกรดเป็น PRO เพื่อใช้ฟีเจอร์นี้',
    newLeads: (n: number) => `ลูกค้าใหม่ ${n} รายการ`,
    openLeads: 'ดูรายชื่อลูกค้า',
  },
  team: {
    title: 'ทีมงาน',
    members: 'สมาชิก',
    role: 'บทบาท',
    invite: 'เชิญสมาชิก',
    inviteEmail: 'อีเมลของผู้ที่จะเชิญ',
    inviteSubmit: 'ส่งคำเชิญ',
    pending: 'คำเชิญที่รอตอบรับ',
    revoke: 'ยกเลิกคำเชิญ',
    readOnly: 'เฉพาะเจ้าของเว็บไซต์เท่านั้นที่จัดการทีมได้',
    acceptTitle: 'ตอบรับคำเชิญ',
    accepted: 'เข้าร่วมทีมเรียบร้อยแล้ว',
    goToSite: 'ไปที่เว็บไซต์',
    // u48
    you: '(คุณ)',
    ownRole: 'บทบาทของตัวเองให้เจ้าของคนอื่นเปลี่ยนให้',
    rolesTitle: 'แต่ละบทบาททำอะไรได้บ้าง',
    roleHelp: {
      owner: 'ทำได้ทุกอย่าง รวมถึงแพ็กเกจ การชำระเงิน โดเมน และสมาชิก',
      editor: 'แก้เนื้อหา หน้าเว็บ เมนู และเผยแพร่ได้ แต่จัดการแพ็กเกจและสมาชิกไม่ได้',
      support_viewer: 'ดูข้อมูลและสถิติได้ แต่แก้ไขไม่ได้',
    },
    invited: (email: string) => `ส่งคำเชิญไปที่ ${email} แล้ว`,
    roleChanged: (email: string, role: string) => `เปลี่ยนบทบาทของ ${email} เป็น ${role} แล้ว`,
    revoked: (email: string) => `ยกเลิกคำเชิญของ ${email} แล้ว`,
    removed: (email: string) => `ลบ ${email} ออกจากทีมแล้ว`,
    removeTitle: (email: string) => `ลบ ${email} ออกจากทีม?`,
    removeEffect: 'เขาจะเข้าจัดการเว็บไซต์นี้ไม่ได้อีก ถ้าต้องการให้กลับมา ต้องส่งคำเชิญใหม่',
    removeButton: 'ลบออกจากทีม',
  },
  security: {
    title: 'ความปลอดภัยของบัญชี',
    twoFactor: 'การยืนยันตัวตนสองขั้นตอน (2FA)',
    enabled: 'เปิดใช้งานอยู่',
    disabled: 'ยังไม่ได้เปิดใช้งาน',
    enable: 'เปิดใช้งาน 2FA',
    scan: 'สแกน QR ด้วยแอปยืนยันตัวตน (เช่น Google Authenticator) แล้วกรอกรหัส 6 หลักเพื่อยืนยัน',
    secretLabel: 'หรือกรอกรหัสนี้ในแอปด้วยตนเอง',
    recoveryTitle: 'รหัสกู้คืน (แสดงเพียงครั้งเดียว)',
    recoveryHelp:
      'เก็บรหัสเหล่านี้ไว้ในที่ปลอดภัย ใช้แทนรหัสจากแอปได้รหัสละ 1 ครั้งเมื่อคุณไม่มีโทรศัพท์',
    recoveryDone: 'ฉันเก็บรหัสกู้คืนเรียบร้อยแล้ว',
    disable: 'ปิดการใช้งาน 2FA',
    disableHelp: 'ยืนยันด้วยรหัสผ่านและรหัสจากแอป',
  },
  profile: {
    title: 'ข้อมูลบัญชี',
    // u16 D7: per-device theme.
    themeTitle: 'ธีมการแสดงผล',
    themeHelp: 'ใช้กับหน้าจัดการเว็บไซต์บนอุปกรณ์นี้เท่านั้น ไม่เปลี่ยนหน้าตาเว็บไซต์ของคุณ',
    themes: { light: 'สว่าง', dark: 'มืด', system: 'ตามระบบ' },
    emailStatus: 'สถานะอีเมล',
    verified: 'ยืนยันแล้ว',
    unverified: 'ยังไม่ยืนยัน',
    phoneTitle: 'เบอร์มือถือ',
    phoneHelp: 'ต้องยืนยันเบอร์มือถือไทยก่อนเผยแพร่เว็บไซต์แพ็กเกจฟรี',
    phone: 'เบอร์มือถือ',
    sendCode: 'ส่งรหัสยืนยัน',
    codeSent: 'ส่งรหัสทาง SMS แล้ว',
    smsCode: 'รหัสจาก SMS',
    phoneVerified: 'ยืนยันเบอร์มือถือแล้ว',
    deleteTitle: 'ลบบัญชี',
    deleteHelp: 'ลบบัญชีและข้อมูลส่วนตัวของคุณอย่างถาวร ไม่สามารถกู้คืนได้',
    deleteSubmit: 'ลบบัญชีถาวร',
    soleOwner: 'เว็บไซต์ที่คุณเป็นเจ้าของคนเดียว:',
  },
  admin: {
    // u28 D9: the feedback queue.
    fb: {
      all: 'ทุกสถานะ',
      allKinds: 'ทุกประเภท',
      search: 'ค้นหาหัวข้อหรือเลขรายการ',
      searchSubmit: 'ค้นหา',
      none: 'ไม่มีรายการ',
      pick: 'เลือกรายการทางซ้ายเพื่อดูรายละเอียด',
      reporterRole: (r: string) => `สิทธิ์: ${r}`,
      setStatus: 'เปลี่ยนสถานะ',
      duplicateOf: 'ซ้ำกับรายการ (เลขรายการ)',
      saveStatus: 'บันทึกสถานะ',
      reply: 'ตอบผู้แจ้ง',
      internal: 'เป็นโน้ตภายใน (ผู้แจ้งไม่เห็น)',
      sendReply: 'ส่ง',
      screenshot: 'ภาพหน้าจอที่แนบมา',
      unknownSite: '—',
    },
    title: 'ผู้ดูแลแพลตฟอร์ม',
    nav: 'ผู้ดูแลระบบ',
    tabs: {
      quarantine: 'คิวตรวจสอบ',
      sites: 'เว็บไซต์',
      vip: 'VIP',
      billing: 'การเงิน',
      domains: 'โดเมน',
      legal: 'Log กฎหมาย',
      banned: 'ตัวบ่งชี้ต้องห้าม',
      feedback: 'แจ้งปัญหา / ฟีเจอร์',
    },
    reasonTitle: 'ระบุเหตุผล',
    reasonHelp: 'ทุกการกระทำของผู้ดูแลจะถูกบันทึกพร้อมเหตุผล (อย่างน้อย 5 ตัวอักษร)',
    reasonShort: 'กรุณาระบุเหตุผลอย่างน้อย 5 ตัวอักษร',
    caseRef: 'เลขอ้างอิงคดี / หนังสือขอข้อมูล',
    confirm: 'ยืนยัน',
    done: 'บันทึกแล้ว',
    search: 'ค้นหาเว็บไซต์ (รหัส, subdomain, ชื่อ, โดเมน)',
    searchButton: 'ค้นหา',
    noResults: 'ไม่พบเว็บไซต์',
    leadsCount: (n: number) => `ลูกค้าติดต่อ ${n} รายการ`,
    reportsCount: (n: number) => `รายงานที่เปิดอยู่ ${n}`,
    killed: 'Kill แล้ว',
    suspend: 'ระงับชั่วคราว',
    unsuspend: 'ยกเลิกการระงับ',
    legalHold: 'เก็บหลักฐาน (Legal hold)',
    // u15 D6: a bank transfer recorded by staff.
    manualPay: 'บันทึกการชำระเงิน (โอน)',
    manualPayHelp:
      'ตรวจยอดในบัญชีบริษัทให้ตรงกับแพ็กเกจก่อน ระบบเก็บเฉพาะเลขอ้างอิงการโอน (ไม่เก็บสลิปหรือชื่อผู้โอน)',
    product: 'แพ็กเกจ',
    transferRef: 'เลขอ้างอิงการโอน',
    transferRefHint: 'เช่น เลขที่รายการจากสลิปหรือ statement (4–60 ตัวอักษร)',
    manualPayDone: (inv: string | null, amount: string, until: string) =>
      `บันทึกแล้ว${inv ? ` ${inv}` : ''} · ฿${amount} · ใช้ได้ถึง ${until}`,
    statuses: { active: 'ปกติ', silent_quarantine: 'กักกัน', suspended: 'ระงับ' },
    vipEmpty: 'ไม่มีงาน VIP ค้าง',
    vipAge: (d: number) => `${d} วันตั้งแต่ชำระเงิน`,
    vipNext: 'ขั้นถัดไป',
    vipStates: {
      waiting_client_assets: 'รอข้อมูลจากลูกค้า',
      in_progress: 'กำลังทำ',
      review_round_1: 'ตรวจรอบ 1',
      review_round_2: 'ตรวจรอบ 2',
      completed: 'เสร็จสิ้น',
      none: '—',
    },
    refunds: 'ใบเสร็จที่คืนเงิน รอการตัดสินใจ',
    refundsEmpty: 'ไม่มีรายการรอตัดสินใจ',
    keepPlan: 'คงแพ็กเกจ',
    downgrade: 'ลดเป็น FREE ทันที',
    invoices: 'ค้นหาใบเสร็จ',
    invoiceSearch: 'เลขใบเสร็จหรือรหัสเว็บไซต์',
    viewReceipt: 'ดูใบเสร็จ',
    quota: (n: number, q: number) => `Custom hostname ที่ใช้อยู่ ${n} / ${q}`,
    expiring: 'โดเมนที่ทีมงานจดให้ ใกล้หมดอายุ (60 วัน)',
    expiringEmpty: 'ไม่มีโดเมนใกล้หมดอายุ',
    daysLeft: (n: number) => `เหลือ ${n} วัน`,
    registerDomain: 'บันทึกโดเมน .com ที่ทีมงานจดให้',
    tenantId: 'รหัสเว็บไซต์ (tnt_…)',
    hostname: 'ชื่อโดเมน',
    expiresAt: 'วันหมดอายุ',
    holds: 'Legal holds',
    holdsEmpty: 'ยังไม่มี legal hold',
    release: 'ปลดล็อก (ตรวจแล้วไม่ผิด)',
    releaseHold: 'สิ้นสุด hold',
    download: 'ดาวน์โหลด',
    part: (n: number) => `ส่วนที่ ${n}`,
    archives: 'ไฟล์ Log รายชั่วโมง',
    day: 'วันที่',
    records: (n: number) => `${n} รายการ`,
    noFile: 'ไม่มีข้อมูลในชั่วโมงนี้',
    legalOnly: 'ข้อมูลส่วนนี้สำหรับ platform_admin เท่านั้น',
    holdStates: {
      pending: 'กำลังส่งออก',
      exported: 'พร้อมดาวน์โหลด',
      incomplete: 'ข้อมูลไม่ครบ (บางส่วนหมดอายุก่อนคัดลอก)',
      released: 'สิ้นสุดแล้ว',
    },
    archiveStates: {
      pending: 'ยังคัดลอกไม่สำเร็จ กำลังลองใหม่',
      partial: 'คัดลอกยังไม่ครบ',
      complete: 'ครบถ้วน',
      incomplete: 'ข้อมูลไม่ครบ (ต้นทางสุ่มตัวอย่าง)',
      failed: 'คัดลอกไม่สำเร็จ',
    },
    emptyQueue: 'ไม่มีเว็บไซต์ในคิวกักกัน',
    source: 'ที่มา',
    score: 'คะแนนเสี่ยง',
    age: 'รอตรวจ (ชม.)',
    slaBreached: 'เกิน SLA 24 ชม.',
    kill: 'Kill switch',
    killTitle: 'ยืนยันระงับเว็บไซต์ถาวร',
    killHelp:
      'ระบบจะระงับเว็บไซต์ ลบไฟล์เว็บที่เผยแพร่ และนำรูป อีเมล และเบอร์ของเจ้าของเข้าบัญชีดำทันที ส่วน LINE เบอร์ และโดเมนที่พบในเนื้อหาจะรอให้ผู้ดูแลอนุมัติก่อนในแท็บบัญชีดำ การกระทำนี้ย้อนกลับไม่ได้ พิมพ์ KILL เพื่อยืนยัน',
    killConfirmLabel: 'พิมพ์ KILL',
    killDone: 'ระงับเว็บไซต์แล้ว',
    indicatorType: 'ประเภท',
    indicatorValue: 'ค่า',
    reason: 'เหตุผล',
    add: 'เพิ่มเข้าบัญชีดำ',
    indicatorStatus: {
      active: 'บังคับใช้อยู่',
      pending: 'รออนุมัติ (ยังไม่มีผลกับเว็บใด)',
      rejected: 'ไม่อนุมัติ',
    },
    pendingOnly: 'เฉพาะที่รออนุมัติ',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    fromSite: 'พบในเว็บ',
    types: {
      phone_hash: 'เบอร์โทร',
      email_canonical_hash: 'อีเมล',
      media_sha256: 'รูปภาพ (SHA-256)',
      line_handle: 'LINE',
      outbound_domain: 'โดเมนขาออก',
    },
    sources: {
      scanner: 'ตัวสแกนข้อความ',
      reports: 'ผู้เข้าชมแจ้ง',
      ai_vision: 'AI ตรวจรูป',
      unknown: 'ไม่ทราบ',
    },
  },
  wizard: {
    title: 'สร้างเว็บไซต์',
    stepOf: (n: number) => `ขั้นตอนที่ ${n} จาก 3`,
    step1: 'ธุรกิจของคุณเป็นแบบไหน',
    step1Help: 'เลือกหมวดธุรกิจและประเภทที่ใกล้เคียงที่สุด เราจะเตรียมข้อความและโครงหน้าเว็บให้',
    subtype: 'ประเภทธุรกิจ',
    // u38
    start: 'เริ่มจากแบบไหน',
    basic: 'เว็บเริ่มต้น 2 หน้า',
    basicHelp: 'หน้าแรกที่รวมเนื้อหาสำคัญ และหน้าติดต่อ เพิ่มหน้าอื่นทีหลังได้',
    kitLabel: (name: string) => `ชุดเว็บสำเร็จรูป: ${name}`,
    kitFree:
      'แพ็กเกจฟรีได้หน้าแรกและหน้าติดต่อทันที หน้าที่เหลือดูตัวอย่างได้ และเพิ่มได้ทันทีเมื่ออัปเกรด',
    step2: 'ข้อมูลติดต่อของธุรกิจ',
    step2Help: 'กรอก 3 ช่องนี้แล้วเราจะสร้างเว็บไซต์ตัวอย่างให้ทันที',
    businessName: 'ชื่อธุรกิจ / ชื่อแบรนด์',
    phone: 'เบอร์โทรศัพท์ติดต่อ',
    line: 'LINE (เช่น @ชื่อร้าน หรือลิงก์ lin.ee)',
    lineChoice: 'บัญชี LINE นี้เป็นแบบไหน',
    lineOfficial: 'LINE Official (เติม @ ให้อัตโนมัติ)',
    linePersonal: 'LINE ส่วนตัว',
    create: 'สร้างเว็บไซต์ทันที',
    next: 'ถัดไป',
    back: 'ย้อนกลับ',
    step3: 'เว็บไซต์ตัวอย่างของคุณพร้อมแล้ว',
    step3Help: 'ลองเปลี่ยนสไตล์ได้ในคลิกเดียว แล้วไปแก้ไขรายละเอียดต่อ',
    style: 'สไตล์เว็บไซต์',
    publish: 'เผยแพร่เว็บไซต์',
    edit: 'ไปแก้ไขเว็บไซต์ต่อ',
    publishSoon:
      'เว็บไซต์ของคุณถูกบันทึกเป็นฉบับร่างแล้ว ปุ่มเผยแพร่จะเปิดใช้งานในรุ่นถัดไป ระหว่างนี้แก้ไขเนื้อหาได้เต็มที่',
    previewTitle: 'ตัวอย่างเว็บไซต์',
  },
  pages: {
    title: 'หน้าเว็บ',
    add: 'เพิ่มหน้า',
    edit: 'แก้ไข',
    duplicate: 'ทำสำเนา',
    delete: 'ลบหน้า',
    confirmDelete: (title: string) =>
      `ลบหน้า "${title}" ใช่ไหม เมนูที่ลิงก์มาหน้านี้จะแสดงเป็นลิงก์เสีย`,
    unpublished: 'มีการแก้ไขที่ยังไม่เผยแพร่',
    pageType: 'ประเภทหน้า',
    pageTitle: 'ชื่อหน้า',
    slug: 'ที่อยู่หน้า (เช่น /about)',
    useTemplate: 'เริ่มจากเนื้อหาตัวอย่าง',
    create: 'สร้างหน้า',
    home: 'หน้าแรก',
    types: {
      home: 'หน้าแรก',
      about: 'เกี่ยวกับเรา',
      services: 'บริการ',
      portfolio: 'ผลงาน',
      contact: 'ติดต่อ',
      landing: 'หน้าโปรโมชัน',
      not_found_404: 'หน้า 404',
      custom: 'หน้าอื่นๆ',
    },
    welcome: 'สร้างเว็บไซต์เรียบร้อย เลือกหน้าที่ต้องการแก้ไขได้เลย',
  },
  // 260929-brand-color (Q1–Q3 = A).
  brandColor: {
    title: 'สีแบรนด์ของคุณ',
    pro: 'เฉพาะ PRO',
    help: 'เลือกสีแบรนด์สีเดียว ระบบจะปรับสีรอง พื้นหลัง และสีตัวอักษรให้เข้ากันและอ่านง่ายอัตโนมัติ',
    lockedHelp: 'แพ็กเกจฟรีเลือกชุดสีสำเร็จรูปได้ทุกชุด อัปเกรดเป็น PRO เพื่อใช้สีแบรนด์ของคุณเอง',
    upgrade: 'ดูแพ็กเกจ PRO',
    use: 'ใช้สีแบรนด์ของฉันแทนสีของสไตล์',
    pick: 'เลือกสี',
    hex: 'รหัสสี',
    badHex: 'ใส่รหัสสีแบบ #RRGGBB เช่น #1565A8',
    ok: 'ผ่านเกณฑ์อ่านง่าย (WCAG AA) ทุกส่วนของเว็บ',
    fails: 'สีนี้ทำให้ข้อความบางส่วนอ่านได้ไม่ชัดพอ',
    chosen: 'สีที่เลือก',
    suggested: 'แนะนำ',
    beforeLabel: 'ตัวอย่างชุดสีจากสีที่เลือก',
    afterLabel: 'ตัวอย่างชุดสีจากสีที่แนะนำ',
    whatChanges: 'สีที่แนะนำคือเฉดเดิมที่ปรับความเข้มเล็กน้อย เพื่อให้ข้อความอ่านได้ชัดขึ้น',
    useSuggestion: 'ใช้สีที่แนะนำ',
    preview: 'ตัวอย่างหน้าแรก',
    previewHelp: 'เปลี่ยนสไตล์หรือสีแล้วดูผลได้ทันที ยังไม่บันทึกจนกว่าจะกดบันทึก',
  },
  // u48: the one "unsaved changes" question, everywhere.
  leaveGuard: {
    title: 'ยังไม่ได้บันทึกการแก้ไข',
    body: 'ถ้าออกจากหน้านี้ การแก้ไขที่ยังไม่บันทึกจะหายไป',
    stay: 'อยู่หน้านี้ต่อ',
    leave: 'ออกโดยไม่บันทึก',
  },
  // u44: shared page pieces.
  locked: {
    pro: 'เฉพาะ PRO',
    proAnnual: 'เฉพาะ PRO รายปี',
    seePlans: 'ดูแพ็กเกจ PRO',
  },
  publishing: {
    help: 'เวอร์ชันของเว็บไซต์ที่ออนไลน์ และการพาผู้เข้าชมจากลิงก์เก่าไปหน้าใหม่',
    versions: 'ประวัติเวอร์ชัน',
    redirects: 'Redirects',
  },
  // u44: one publish status for the whole back office (Save = keep; Publish = change the live site).
  publishState: {
    pending: 'มีการเปลี่ยนแปลงรอเผยแพร่',
    current: 'เว็บไซต์เป็นเวอร์ชันล่าสุด',
    never: 'ยังไม่ได้เผยแพร่',
  },
  // u38: "เพิ่มหน้าจากชุดเว็บ".
  kits: {
    open: 'เพิ่มหน้าจากชุดเว็บ',
    title: 'เพิ่มหน้าจากชุดเว็บ',
    kit: 'ชุดเว็บ',
    pages: 'หน้าในชุดนี้',
    exists: 'มีแล้ว',
    proOnly: 'เฉพาะ PRO',
    preview: 'ดูตัวอย่าง',
    hidePreview: 'ซ่อนตัวอย่าง',
    lockedTitle: (n: number) => `อีก ${n} หน้าพร้อมใช้เมื่ออัปเกรดเป็น PRO`,
    lockedHelp:
      'กดดูตัวอย่างได้ทุกหน้า หน้าตาจะเป็นแบบนี้บนเว็บของคุณ อัปเกรดแล้วเพิ่มได้ในคลิกเดียว',
    upgrade: 'ดูแพ็กเกจ PRO',
    overCap: (n: number) => `แพ็กเกจของคุณเพิ่มได้อีก ${n} หน้า เลือกให้น้อยลงหรืออัปเกรด`,
    updateMenus: 'จัดเมนูตามชุดเว็บ',
    updateMenusHelp:
      'เมนูบน เมนูท้ายเว็บ และปุ่มบนหัวเว็บจะถูกแทนด้วยของชุดเว็บ (หน้าเดิมไม่ถูกแก้)',
    applyVibe: 'ใช้สไตล์สีของชุดเว็บนี้ด้วย',
    add: (n: number) => (n > 0 ? `เพิ่ม ${n} หน้า` : 'เลือกหน้าที่ต้องการ'),
    needsContact: 'กรอกข้อมูลติดต่อในหน้าตั้งค่าก่อน แล้วจึงเพิ่มหน้าจากชุดเว็บ',
  },
  editor: {
    back: 'กลับไปรายการหน้า',
    sections: 'ส่วนในหน้านี้',
    // u22: canvas editor.
    canvas: 'หน้าเว็บของคุณ (คลิกส่วนที่ต้องการแก้)',
    devices: { desktop: 'คอมพิวเตอร์', tablet: 'แท็บเล็ต', mobile: 'มือถือ' },
    tabErrors: (n: number) => `(${n} ช่องต้องแก้)`,
    sectionMenu: (name: string) => `จัดการส่วน: ${name}`,
    confirmRemove: 'ยืนยันลบส่วนนี้',
    // u24
    insertHere: 'เพิ่มส่วนตรงนี้',
    insertAt: (n: number) => `เพิ่มส่วนเป็นลำดับที่ ${n}`,
    chooseVariant: 'เลือกหน้าตา',
    backToBlocks: '← เลือกใหม่',
    undo: 'เลิกทำ',
    redo: 'ทำซ้ำ',
    moved: (name: string, n: number, total: number) => `ย้าย ${name} ไปลำดับที่ ${n} จาก ${total}`,
    dragHint: 'ลากเพื่อเรียงลำดับ',
    // u25: canvas first, tools on demand.
    structure: 'โครงสร้างหน้า',
    closeStructure: 'ปิดโครงสร้างหน้า',
    switchPage: (title: string) => `หน้าที่กำลังแก้: ${title} (เปลี่ยนหน้า)`,
    allPages: 'จัดการหน้าทั้งหมด',
    previewMode: 'ดูตัวอย่าง',
    backToEdit: 'กลับมาแก้ไข',
    more: 'ตัวเลือกเพิ่มเติมของหน้านี้',
    publish: 'เผยแพร่',
    closeInspector: 'ปิดแผงแก้ไข',
    // u26: edit where you look.
    editText: '✎ แก้ข้อความ',
    editSection: 'แก้ไข',
    whatToAdd: 'คุณอยากเพิ่มอะไร?',
    chooseLayout: 'เลือกหน้าตาที่ชอบ เปลี่ยนทีหลังได้เสมอ',
    moreLook: 'ปรับหน้าตา',
    moreAdmin: 'ตัวเลือกสำหรับผู้ดูแล',
    moreAdminHelp: 'การวัดผลโฆษณาและลิงก์มาที่ส่วนนี้ ส่วนใหญ่ไม่ต้องแก้',
    emptyTitle: 'เริ่มสร้างหน้านี้',
    emptyHelp: 'เลือกส่วนแรกที่อยากให้ลูกค้าเห็น แล้วค่อยเติมส่วนอื่นทีหลัง',
    addFirst: 'เพิ่มส่วนแรก',
    tip: {
      title: 'เริ่มแก้เว็บไซต์ใน 3 ขั้น',
      steps: [
        'คลิกส่วนบนหน้าเว็บเพื่อเลือก',
        'ชี้ที่ข้อความแล้วกด "✎ แก้ข้อความ" เพื่อพิมพ์บนหน้าเว็บได้เลย',
        'กด "+ เพิ่มส่วน" ใต้ส่วนไหนก็ได้เพื่อเพิ่มเนื้อหา',
      ],
      dismiss: 'เข้าใจแล้ว',
    },
    anchorTitle: 'ลิงก์มาที่ส่วนนี้',
    anchorHelp: 'ใช้ลิงก์นี้ในปุ่มหรือเมนูเพื่อพาผู้เข้าชมมาที่ส่วนนี้ของหน้า',
    addBlock: 'เพิ่มส่วน',
    variant: 'หน้าตาของส่วนนี้',
    // u18 D6: section presentation.
    style: {
      title: 'รูปแบบการแสดงผล',
      help: 'สีและระยะห่างมาจากธีมของเว็บเสมอ เลือก "อัตโนมัติ" เพื่อให้ระบบจัดให้',
      tone: 'พื้นหลัง',
      spacing: 'ระยะห่าง',
      align: 'ตำแหน่งหัวข้อ',
      motion: 'การเคลื่อนไหว',
      motionAuto: 'ตามการตั้งค่าเว็บไซต์',
      auto: 'อัตโนมัติ (ตามธีม)',
      options: {
        plain: 'สีพื้นหน้า',
        soft: 'สีรอง',
        brand: 'สีแบรนด์',
        compact: 'แคบ',
        normal: 'ปกติ',
        spacious: 'กว้าง',
        start: 'ชิดซ้าย',
        center: 'กึ่งกลาง',
        off: 'ไม่มี',
        subtle: 'นุ่มนวล',
        lively: 'มีชีวิตชีวา',
      },
    },
    add: 'เพิ่ม',
    moveUp: 'เลื่อนขึ้น',
    moveDown: 'เลื่อนลง',
    duplicate: 'ทำสำเนา',
    remove: 'ลบ',
    noSections: 'หน้านี้ยังไม่มีส่วนใด กด "เพิ่มส่วน" เพื่อเริ่ม',
    saving: 'กำลังบันทึก…',
    saved: 'บันทึกฉบับร่างแล้ว',
    unsaved: 'ยังไม่ได้บันทึก',
    saveFailed: 'บันทึกไม่สำเร็จ',
    conflict: 'มีคนแก้ไขหน้านี้จากที่อื่น การแก้ไขล่าสุดของคุณยังไม่ถูกบันทึก',
    reload: 'โหลดฉบับล่าสุด',
    invalid: 'บางช่องยังไม่ถูกต้อง ระบบจะบันทึกเมื่อแก้ครบ',
    readOnly: 'คุณมีสิทธิ์ดูอย่างเดียว',
    preview: 'ตัวอย่าง',
    refreshPreview: 'รีเฟรชตัวอย่าง',
    pageSettings: 'ตั้งค่าหน้าและ SEO',
    claimsTitle: 'ข้อความที่อาจผิดกฎโฆษณา',
    claimSuggest: 'แนะนำ:',
    claimBlocks: 'ต้องแก้ก่อนเผยแพร่',
    claimConfirm: 'ต้องยืนยันตอนเผยแพร่',
    addItem: 'เพิ่มรายการ',
    removeItem: 'ลบรายการ',
    item: (n: number) => `รายการที่ ${n}`,
    // u33
    youtube: {
      placeholder: 'วางลิงก์ เช่น https://youtu.be/…',
      help: 'วางลิงก์วิดีโอจาก YouTube ได้ทุกแบบ รวมถึง Shorts วิดีโอจะเล่นในหน้าเว็บของคุณ',
      invalid: 'ลิงก์นี้ไม่ใช่วิดีโอ YouTube',
      preview: 'ภาพปกจาก YouTube',
    },
    mapEmbed: {
      placeholder: '<iframe src="https://www.google.com/maps/embed?pb=…"></iframe>',
      help: 'ใน Google Maps กด แชร์ → ฝังแผนที่ → คัดลอก HTML แล้ววางที่นี่ ถ้าเว้นว่าง แผนที่จะค้นหาจากช่องด้านบน',
      saved: 'ใช้หมุดจากโค้ดฝังนี้แล้ว (ลบข้อความออกเพื่อกลับไปค้นหาจากช่องด้านบน)',
      invalid: 'โค้ดนี้ไม่ใช่โค้ดฝังแผนที่จาก Google Maps',
    },
    optionalGroup: 'ใส่ข้อมูลส่วนนี้',
    none: '— ไม่มี —',
    image: {
      choose: 'เลือกรูป',
      change: 'เปลี่ยนรูป',
      remove: 'เอารูปออก',
      altMode: 'รูปนี้',
      informative: 'สื่อความหมาย (ต้องมีคำอธิบาย)',
      decorative: 'ตกแต่งเท่านั้น',
      altText: 'คำอธิบายรูป (alt)',
      // u23 D6
      stock: 'ภาพตัวอย่างของระบบ — เปลี่ยนเป็นรูปของคุณได้',
      unavailable: 'ยังแสดงรูปนี้ไม่ได้',
      decorativeHelp: 'รูปประกอบบรรยากาศ ไม่ต้องใส่คำอธิบาย โปรแกรมอ่านหน้าจอจะข้ามไป',
      altHint: 'บอกสิ่งที่เห็นในรูปสั้น ๆ เช่น "ห้องทำฟันที่สะอาด มีเก้าอี้ทำฟันสีฟ้า"',
    },
    // u23 D5: link picker.
    link: {
      opensTo: 'เปิดไปที่',
      kinds: {
        none: 'ไม่มีลิงก์',
        line: 'LINE ของร้าน',
        phone: 'โทรหาร้าน',
        page: 'หน้าในเว็บ',
        section: 'ส่วนในหน้านี้',
        other: 'ลิงก์อื่น (พิมพ์เอง)',
      },
      lineOf: (d: string) => `ผู้เข้าชมจะเปิดแชท LINE ${d}`,
      phoneOf: (d: string) => `ผู้เข้าชมจะโทรไปที่ ${d}`,
      otherHint: 'ใช้ได้เฉพาะลิงก์ที่ขึ้นต้นด้วย https://, tel: หรือ mailto:',
      choose: '— เลือก —',
    },
    seo: {
      description: 'คำอธิบายสำหรับ Google (meta description)',
      canonical: 'Canonical URL (ถ้ามี)',
      ogImage: 'รูปสำหรับแชร์ (OG image)',
      schemaType: 'ประเภทข้อมูลโครงสร้าง',
      noindex: 'ไม่ให้ Google เก็บหน้านี้ (noindex)',
      hideNav: 'ซ่อนเมนูด้านบนในหน้านี้',
    },
  },
  // u25 D6: what each section is for, in the owner's words (no developer names such as "Hero").
  blocks: {
    hero_banner: 'ส่วนเปิดหน้า',
    image_text_split: 'รูปคู่ข้อความ',
    feature_grid: 'จุดเด่นของธุรกิจ',
    service_catalog_grid: 'บริการและสินค้า',
    gallery_showcase: 'ภาพผลงาน',
    pricing_promo_cards: 'ราคาและโปรโมชัน',
    faq_accordion: 'คำถามที่พบบ่อย',
    contact_lead_section: 'ติดต่อเรา',
    video_showcase: 'วิดีโอ',
    map_location: 'แผนที่ร้าน',
    stats_band: 'ตัวเลขความน่าเชื่อถือ',
    cta_band: 'แถบชวนตัดสินใจ',
    team_grid: 'ทีมงาน',
    property_listing: 'ทรัพย์สิน (อสังหาฯ)',
  },
  // u26 D10: what the owner wants to add, in their words (each maps to a block and its layouts).
  purposes: {
    services: ['แนะนำบริการหรือสินค้า', 'รายการบริการ สินค้า หรือเมนูพร้อมราคา'],
    gallery: ['ภาพผลงาน', 'ผลงานที่ผ่านมาหรือบรรยากาศร้าน'],
    highlights: ['จุดเด่นของธุรกิจ', 'เหตุผลที่ลูกค้าควรเลือกคุณ'],
    reviews: ['เสียงจากลูกค้า', 'รีวิวหรือโลโก้ลูกค้าที่ไว้ใจคุณ'],
    steps: ['ขั้นตอนการใช้บริการ', 'บอกลูกค้าว่าเริ่มต้นอย่างไร ทีละขั้น'],
    about: ['รูปกับข้อความ', 'เช่น เกี่ยวกับเรา หรือเรื่องราวของร้าน'],
    pricing: ['ราคาและโปรโมชัน', 'แพ็กเกจราคาหรือโปรโมชันพิเศษ'],
    faq: ['คำถามที่พบบ่อย', 'ตอบคำถามที่ลูกค้าถามบ่อยก่อนติดต่อ'],
    contact: ['ติดต่อเรา', 'ช่องทางติดต่อและฟอร์มให้ลูกค้าฝากข้อมูล'],
    links: ['รายการลิงก์', 'ปุ่มลิงก์เรียงกัน เช่น หน้าโปรไฟล์ของคุณ'],
    video: ['วิดีโอ', 'วิดีโอ YouTube ที่เล่นได้ในหน้าเว็บ'],
    map: ['แผนที่ร้าน', 'แผนที่พร้อมปุ่มนำทาง ให้ลูกค้าหาร้านเจอ'],
    stats: ['ตัวเลขความน่าเชื่อถือ', 'ตัวเลขเด่น เช่น จำนวนลูกค้า ปีประสบการณ์ คะแนนรีวิว'],
    ctaBand: ['แถบชวนตัดสินใจ', 'ข้อความสั้นพร้อมปุ่ม ชวนลูกค้าติดต่อหรือจอง'],
    team: ['ทีมงาน', 'รูป ชื่อ และตำแหน่งของคนในทีม'],
    properties: ['ทรัพย์สิน (อสังหาฯ)', 'บ้าน คอนโด หรือที่ดิน พร้อมราคา สถานะ และขนาด'],
    opening: ['ส่วนเปิดหน้า', 'หัวข้อใหญ่พร้อมปุ่มติดต่อ มักอยู่บนสุดของหน้า'],
  },
  menus: {
    title: 'เมนูเว็บไซต์',
    header: 'เมนูด้านบน',
    footer: 'เมนูด้านล่าง',
    // u29: the structure editor.
    shownAt: { header: 'แสดงที่: แถบด้านบนของทุกหน้า', footer: 'แสดงที่: ท้ายเว็บทุกหน้า' },
    label: 'ชื่อเมนู',
    opensTo: 'เปิดไปที่',
    visible: 'แสดงบนเว็บ',
    hidden: 'ซ่อนอยู่',
    hiddenHelp: 'เว็บจริงไม่มีเมนูนี้',
    add: 'เพิ่มเมนู',
    addChild: 'เพิ่มเมนูย่อย',
    addTitle: 'เพิ่มเมนู',
    addChildTitle: (parent: string) => `เพิ่มเมนูย่อยใน "${parent}"`,
    addSubmit: 'เพิ่ม',
    nest: 'ทำเป็นเมนูย่อยของ…',
    nestTitle: (label: string) => `ย้าย "${label}" ไปเป็นเมนูย่อยของ`,
    nestHasChildren: 'เมนูที่มีเมนูย่อยอยู่แล้วย้ายไปซ้อนไม่ได้ (ซ้อนได้ 2 ชั้น)',
    nestFull: 'เต็มแล้ว',
    nestSubmit: 'ย้าย',
    outdent: 'ย้ายออกเป็นเมนูหลัก',
    moveUp: 'เลื่อนขึ้น',
    moveDown: 'เลื่อนลง',
    remove: 'ลบ',
    removeConfirm: 'ยืนยันลบ',
    removeWithChildren: (n: number) => `ยืนยันลบ (รวมเมนูย่อย ${n} รายการ)`,
    more: (label: string) => `ตัวเลือกของเมนู ${label}`,
    edit: (label: string) => `แก้เมนู "${label}"`,
    close: 'ปิด',
    dangling: 'ลิงก์เสีย: หน้าที่เคยเชื่อมไว้ถูกลบแล้ว',
    pickNewPage: 'เลือกหน้าใหม่',
    to: {
      page: (title: string) => `หน้า: ${title}`,
      section: (name: string) => `ส่วน: ${name}`,
      sectionUnknown: 'ส่วนของหน้า',
      line: 'LINE ของร้าน',
      phone: 'โทรหาร้าน',
      email: (addr: string) => `อีเมล ${addr}`,
      external: (host: string) => `ลิงก์ไปที่ ${host}`,
    },
    countTop: (n: number, max: number) => `${n} / ${max} เมนูหลัก`,
    full: (max: number) => `ครบ ${max} เมนูแล้ว`,
    empty: 'ยังไม่มีเมนู',
    emptyHelp: 'เพิ่มเมนูเพื่อให้ผู้เข้าชมไปยังหน้าต่าง ๆ ได้ง่าย',
    sectionName: (page: string, name: string) => `${page} › ${name}`,
    // Save bar and leaving.
    unsaved: 'ยังไม่ได้บันทึก',
    saved: 'บันทึกแล้ว',
    discard: 'ยกเลิกการเปลี่ยนแปลง',
    save: 'บันทึกเมนู',
    leaveTitle: 'ยังไม่ได้บันทึกเมนู',
    leaveBody: 'มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ต้องการออกจากหน้านี้หรือไม่?',
    stay: 'อยู่หน้านี้ต่อ',
    leave: 'ออกโดยไม่บันทึก',
    // Header button (u29: rendered on the site; the footer has no button).
    cta: 'ปุ่มเด่นมุมขวาบน',
    ctaHelp: 'แสดงที่แถบด้านบนบนจอคอมพิวเตอร์',
    ctaLine: (line: string) => `ใช้ LINE ของร้าน${line ? ` (${line})` : ''}`,
    ctaOwn: 'ใช้ปุ่มของฉัน',
    ctaLabel: 'ข้อความบนปุ่ม',
    ctaNeedsBoth: 'กรอกข้อความบนปุ่มและเลือกปลายทางให้ครบ',
    // u30
    preview: {
      title: 'ตัวอย่างบนเว็บ (ยังไม่บันทึกก็เห็นได้)',
      frame: 'ตัวอย่างเมนูบนเว็บไซต์',
      devices: { desktop: 'คอมพิวเตอร์', mobile: 'มือถือ' },
    },
    dropHere: 'วางตรงนี้',
    dropInto: (parent: string) => `↳ วางเป็นเมนูย่อยของ "${parent}"`,
    dragHint: 'ลากเพื่อจัดลำดับ หรือวางบนเมนูหลักเพื่อทำเป็นเมนูย่อย',
    moved: (label: string) => `ย้าย "${label}" แล้ว`,
    quickStart: 'เริ่มต้นเร็วขึ้น',
    build: 'สร้างเมนูจากหน้าที่มี',
    addOwn: 'เพิ่มเมนูเอง',
    buildTitle: 'เลือกหน้าที่ต้องการใส่ในเมนู',
    buildHelp: 'ติ๊กไว้ให้แล้วสำหรับหน้าที่มักอยู่ในเมนู เปลี่ยนได้ตามต้องการ',
    buildSubmit: (n: number) => `สร้างเมนู (${n} รายการ)`,
    buildNone: 'ยังไม่มีหน้าที่ใส่ในเมนูได้',
  },
  media: {
    title: 'คลังรูป',
    upload: 'อัปโหลดรูป',
    uploadHelp:
      'รองรับ JPG, PNG, WebP ระบบย่อขนาดและลบข้อมูลตำแหน่ง (EXIF) ในเครื่องคุณก่อนอัปโหลด',
    preparing: (name: string) => `กำลังเตรียมรูป ${name}…`,
    uploading: 'กำลังอัปโหลด…',
    uploaded: 'อัปโหลดเรียบร้อย',
    duplicate: 'รูปนี้มีอยู่ในคลังแล้ว',
    empty: 'ยังไม่มีรูปในคลัง',
    delete: 'ลบรูป',
    inUse: 'ลบไม่ได้ เพราะรูปนี้ยังถูกใช้อยู่ในหน้า:',
    inUseSite: 'ลบไม่ได้ เพราะรูปนี้ใช้เป็นโลโก้หรือรูป SEO ของเว็บไซต์',
    unsupported: 'ไฟล์นี้ไม่ใช่รูปที่รองรับ (JPG, PNG, WebP)',
    tooSmall: 'รูปเล็กเกินไป (อย่างน้อย 16×16 พิกเซล)',
    encodeFailed: 'แปลงรูปไม่สำเร็จ กรุณาลองรูปอื่น',
    pick: 'เลือกรูปจากคลัง',
    more: 'ดูเพิ่มเติม',
  },
  settings: {
    title: 'ตั้งค่าเว็บไซต์',
    business: 'ข้อมูลธุรกิจ',
    address: 'ที่อยู่ (ใช้กับ Google ถ้ากรอกครบ)',
    street: 'บ้านเลขที่ / ถนน',
    locality: 'แขวง / ตำบล / เขต',
    region: 'จังหวัด',
    postalCode: 'รหัสไปรษณีย์',
    sameAs: 'ลิงก์โซเชียลของธุรกิจ (บรรทัดละ 1 ลิงก์)',
    // u39
    social: {
      title: 'โซเชียลมีเดีย',
      help: 'วางลิงก์หน้าเพจหรือโปรไฟล์ ระบบรู้เองว่าเป็นแพลตฟอร์มไหนและแสดงไอคอนให้',
      add: 'เพิ่มลิงก์โซเชียล',
      addButton: 'เพิ่ม',
      placeholder: 'เช่น https://www.facebook.com/ร้านของคุณ',
      detected: (name: string) => `รู้จักแล้ว: ${name}`,
      unsupported: 'ยังไม่รองรับลิงก์นี้ — ใช้ลิงก์ https ของแพลตฟอร์มโซเชียลหรือร้านค้าออนไลน์',
      unknown: 'ลิงก์อื่น',
      remove: (name: string) => `ลบลิงก์ ${name}`,
      placement: 'แสดงไอคอนที่',
      places: {
        footer: 'ท้ายเว็บ (ทุกหน้า)',
        header: 'แถบด้านบน (และเมนูบนมือถือ)',
        contact: 'ส่วน "ติดต่อเรา"',
      },
    },
    privacyUrl: 'ลิงก์นโยบายความเป็นส่วนตัวของคุณ (ถ้าไม่มี ระบบสร้างให้)',
    style: 'สไตล์และโลโก้',
    logo: 'โลโก้',
    // u31
    motion: 'การเคลื่อนไหวของเว็บไซต์',
    motionHelp:
      'ส่วนต่าง ๆ ค่อย ๆ ปรากฏเมื่อเลื่อนถึง ปุ่มและการ์ดตอบสนองเมื่อชี้ ผู้เข้าชมที่ตั้งเครื่องให้ลดการเคลื่อนไหวจะไม่เห็นการขยับเสมอ',
    motionLevels: {
      off: ['ไม่มี', 'หน้าเว็บนิ่ง'],
      subtle: ['นุ่มนวล', 'ขยับเล็กน้อย เหมาะกับทุกธุรกิจ'],
      lively: ['มีชีวิตชีวา', 'ขยับชัดขึ้น เหมาะกับร้านที่อยากดูสนุก'],
    },
    seo: 'SEO ของทั้งเว็บ',
    titleSuffix: 'ข้อความต่อท้ายชื่อหน้า',
    defaultDescription: 'คำอธิบายเว็บไซต์',
    defaultOgImage: 'รูปสำหรับแชร์ (ค่าเริ่มต้น)',
    subdomain: 'ชื่อโดเมนย่อย',
    subdomainLocked: 'เปลี่ยนได้เฉพาะก่อนเผยแพร่ครั้งแรก',
    // u45: one form, three tabs, one save bar.
    tabs: { business: 'ข้อมูลธุรกิจ', look: 'รูปลักษณ์', seo: 'SEO' },
    unsavedIn: (where: string) => `มีการแก้ไขที่ยังไม่บันทึก: ${where}`,
    brandBlocks: 'แก้สีแบรนด์ให้ผ่านเกณฑ์อ่านง่ายก่อนบันทึก (ดูที่แท็บรูปลักษณ์)',
    contact: 'ข้อมูลติดต่อ',
    addressTitle: 'ที่อยู่ร้าน',
    addressHelp: 'ไม่บังคับ ใช้แสดงบนแผนที่และช่วยให้ Google รู้ว่าร้านอยู่ที่ไหน',
    more: 'ข้อมูลเพิ่มเติม',
    theme: 'ธีม',
    previewUnsaved: 'ยังไม่บันทึก',
    seoTitle: 'การค้นหาบน Google',
    siteNameLabel: 'ชื่อเว็บไซต์ในผลการค้นหา',
    siteNameHint: 'ต่อท้ายชื่อทุกหน้า เช่น "ติดต่อเรา | ร้านกาแฟดี"',
    descriptionHint: 'แสดงใต้ชื่อเว็บใน Google แนะนำ 80–160 ตัวอักษร',
    seoAuto:
      'EdgePage สร้าง sitemap และข้อมูลพื้นฐานสำหรับ Google ให้อัตโนมัติ ไม่ต้องตั้งค่าเพิ่ม',
    subdomainAddress: 'ที่อยู่เว็บไซต์',
    subdomainOwnerOnly: 'เฉพาะเจ้าของเว็บไซต์เปลี่ยนได้',
    subdomainImmediate: 'มีผลทันทีหลังบันทึก',
    subdomainSaved: 'เปลี่ยนชื่อแล้ว มีผลทันที',
    // Settings are drafts like pages: the live site changes on the next publish.
    // u44: "saved" only — whether the live site is behind is the header's job.
    saved: 'บันทึกแล้ว',
  },
  publish: {
    pickTitle: (n: number) => `แพ็กเกจปัจจุบันเผยแพร่ได้ ${n} หน้า เลือกหน้าที่ต้องการให้ออนไลน์`,
    pickHelp: 'หน้าอื่นยังเก็บไว้ครบ อัปเกรดเมื่อไหร่ก็เผยแพร่ได้ทั้งหมด',
    button: 'เผยแพร่',
    title: 'เผยแพร่เว็บไซต์',
    intro: 'ระบบจะตรวจเนื้อหา สร้างเว็บไซต์ฉบับใหม่ แล้วสลับขึ้นออนไลน์ทีเดียวทั้งเว็บ',
    // u17 TH-2: advisory, never blocks.
    hiddenReviews: (n: number) =>
      `รีวิว ${n} รายการยังไม่ได้ยืนยัน จะไม่แสดงบนเว็บจริง (ยังเผยแพร่ต่อได้)`,
    hiddenReviewsPage: (title: string, n: number) => `${title} — ${n} รายการ`,
    hiddenReviewsFix: 'ไปยืนยันรีวิว',
    // u21 D3: example copy the owner has not rewritten yet (advisory).
    exampleText: (n: number) =>
      `ข้อความตัวอย่าง ${n} ส่วนยังไม่ได้แก้ ตรวจให้ตรงกับธุรกิจจริง เช่น บริการที่มีจริงและการเดินทาง (ยังเผยแพร่ต่อได้)`,
    exampleTextPage: (title: string, n: number) => `${title} — ${n} ส่วน`,
    exampleTextFix: 'ไปแก้ข้อความ',
    start: 'เริ่มเผยแพร่',
    checking: 'กำลังตรวจเนื้อหา…',
    building: (done: number, total: number) => `กำลังสร้างหน้าเว็บ ${done}/${total}`,
    finalizing: 'กำลังสลับขึ้นออนไลน์…',
    progress: 'ความคืบหน้าการเผยแพร่',
    done: 'เผยแพร่เรียบร้อยแล้ว',
    doneQuarantine: 'เผยแพร่เรียบร้อยแล้ว',
    viewLive: 'เปิดดูเว็บไซต์',
    superseded: 'มีการเผยแพร่ที่ใหม่กว่านี้ขึ้นออนไลน์แล้ว',
    blocked: 'ยังเผยแพร่ไม่ได้ กรุณาแก้รายการต่อไปนี้ก่อน',
    confirmTitle: 'ข้อความโฆษณาที่ต้องยืนยัน',
    confirmHelp: 'ข้อความเหล่านี้ต้องมีหลักฐานรองรับตามกฎหมายโฆษณา',
    confirmCheckbox: 'ฉันยืนยันว่าข้อความเหล่านี้เป็นความจริงและมีหลักฐานรองรับ',
    confirmAndPublish: 'ยืนยันและเผยแพร่',
    verifyEmail: 'กรุณายืนยันอีเมลก่อนเผยแพร่เว็บไซต์',
    verifyPhone: 'กรุณายืนยันเบอร์มือถือก่อนเผยแพร่เว็บไซต์แพ็กเกจฟรี',
    toProfile: 'ไปยืนยันเบอร์มือถือ',
    toDashboard: 'ไปหน้าหลักเพื่อส่งอีเมลยืนยันอีกครั้ง',
    editPage: 'แก้ไขหน้านี้',
    retry: 'ลองอีกครั้ง',
    redirectSkipped: (from: string) =>
      `ไม่ได้สร้าง redirect อัตโนมัติจาก ${from} เพราะเกินจำนวนของแพ็กเกจ`,
    close: 'ปิด',
  },
  versions: {
    title: 'เวอร์ชันที่เผยแพร่',
    help: 'ย้อนกลับแบบทันทีได้กับเวอร์ชันที่ระบบยังเก็บไว้ หรือสร้างใหม่จากเวอร์ชันเก่าในประวัติ (ฉบับร่างของคุณไม่ถูกแตะ)',
    empty: 'ยังไม่เคยเผยแพร่',
    revision: (n: number) => `เวอร์ชัน ${n}`,
    live: 'ออนไลน์อยู่',
    rebuiltFrom: (n: number) => `เผยแพร่ซ้ำจากเวอร์ชัน ${n}`,
    // u46: two ways back, named for what they do; both change the live site, neither the draft.
    instant: 'ย้อนกลับทันที',
    instantHelp:
      'สลับเว็บไซต์จริงกลับเป็นเวอร์ชันนั้นทันที ใช้ได้กับเวอร์ชันล่าสุดที่ระบบเก็บไฟล์ไว้',
    rebuild: 'เผยแพร่เวอร์ชันนี้อีกครั้ง',
    rebuildHelp:
      'สร้างเว็บไซต์จากเนื้อหาของเวอร์ชันนั้นแล้วเผยแพร่เป็นเวอร์ชันใหม่ (ได้เลขเวอร์ชันใหม่ ไม่ใช่เลขเดิม) ใช้กับเวอร์ชันที่เก่ากว่าที่ย้อนทันทีได้',
    preview: 'ดูตัวอย่าง',
    previewLiveButton: 'ดูตัวอย่างเวอร์ชันที่ออนไลน์',
    previewTitle: (n: number) => `ตัวอย่างเวอร์ชัน ${n}`,
    previewLive: 'นี่คือเวอร์ชันที่ออนไลน์อยู่ (ดูอย่างเดียว)',
    previewNotLive: 'ดูอย่างเดียว เวอร์ชันนี้ยังไม่ได้เปลี่ยนเว็บไซต์จริง',
    previewSnapshot:
      'ไฟล์เดิมของเวอร์ชันนี้ไม่ได้เก็บไว้แล้วตามแพ็กเกจ ตัวอย่างสร้างจากข้อมูลที่บันทึกของเวอร์ชันนี้',
    previewDevice: 'ขนาดหน้าจอ',
    previewBack: 'กลับ',
    rollbackThis: 'ย้อนเว็บไซต์กลับเป็นเวอร์ชันนี้',
    draftSafe: 'ทั้งสองแบบเปลี่ยนเฉพาะเว็บไซต์จริง ฉบับร่างที่คุณกำลังแก้ไม่ถูกลบหรือเปลี่ยน',
    rolledBack: (n: number) => `ย้อนเว็บไซต์กลับเป็นเวอร์ชัน ${n} แล้ว`,
    rebuilt: 'สร้างใหม่และขึ้นออนไลน์แล้ว',
    summaryTitle: 'เว็บไซต์ที่ออนไลน์',
    liveNow: (n: number) => `ออนไลน์อยู่: เวอร์ชัน ${n}`,
    publishedAt: (d: string) => `เผยแพร่เมื่อ ${d}`,
    planKeeps: (instant: number, history: number, plan: string) =>
      `ย้อนกลับทันทีได้ ${instant} เวอร์ชันล่าสุด · เผยแพร่เวอร์ชันเก่าซ้ำได้ย้อนหลัง ${history} เวอร์ชัน (แพ็กเกจ ${plan})`,
    lockedTitle: 'ย้อนกลับเวอร์ชัน',
    lockedHelp: 'แพ็กเกจฟรีเก็บเฉพาะเวอร์ชันที่ออนไลน์อยู่ อัปเกรดเพื่อย้อนกลับเวอร์ชันก่อนหน้าได้',
    lockedBullets: [
      'PRO รายเดือน: ย้อนกลับทันที 3 เวอร์ชัน · เผยแพร่ซ้ำย้อนหลัง 10 เวอร์ชัน',
      'PRO รายปี: ย้อนกลับทันที 5 เวอร์ชัน · เผยแพร่ซ้ำย้อนหลัง 30 เวอร์ชัน',
    ],
    confirmTitle: (n: number) => `ย้อนเว็บไซต์กลับเป็นเวอร์ชัน ${n}`,
    confirmLive: (n: number) => `เว็บไซต์ที่เผยแพร่ตอนนี้จะเปลี่ยนกลับเป็นเวอร์ชัน ${n} ทันที`,
    confirmDraft: 'ฉบับร่างปัจจุบันจะไม่ถูกลบ คุณยังกลับมาแก้ฉบับร่างและเผยแพร่ต่อได้',
    confirmButton: (n: number) => `ย้อนเป็นเวอร์ชัน ${n}`,
    rebuildTitle: (n: number) => `เผยแพร่เวอร์ชัน ${n} อีกครั้ง`,
  },
  redirects: {
    title: 'Redirects (ย้ายที่อยู่หน้าเว็บ)',
    help: 'ใช้พาผู้เข้าชมจากลิงก์เก่าไปหน้าใหม่',
    // u46: short rows, details in a panel, delete asks first.
    newButton: 'เพิ่ม redirect',
    goesTo: 'ไปที่',
    editTitle: 'แก้ redirect',
    emptyHelp: 'เมื่อย้ายหรือเปลี่ยนที่อยู่หน้าเว็บ เพิ่ม redirect เพื่อให้ลิงก์เก่ายังใช้ได้',
    on: 'เปิดใช้งาน',
    off: 'ปิดอยู่',
    fromLocked: 'แก้ที่อยู่เดิมไม่ได้ ถ้าต้องการเปลี่ยน ให้ลบแล้วเพิ่มใหม่',
    deleteTitle: 'ลบ redirect นี้?',
    deleteEffect: (from: string, to: string) =>
      `หลังลบ ผู้ที่เข้าที่ ${from} จะไม่ถูกส่งไป ${to} อีก และอาจเจอหน้าไม่พบ`,
    deleteButton: 'ลบ redirect',
    lockedTitle: 'Redirects (ย้ายที่อยู่หน้าเว็บ)',
    lockedBullets: [
      'ลิงก์เก่าที่แชร์ไว้ยังพาลูกค้ามาถึงหน้าใหม่',
      'ไม่เสียอันดับ Google เมื่อเปลี่ยนที่อยู่หน้า',
      'สูงสุด 50 รายการ (PRO รายเดือน) หรือ 500 รายการ (PRO รายปี)',
    ],
    quota: 'จำนวน redirect',
    from: 'ที่อยู่เดิม (เช่น /old-page)',
    to: 'ปลายทาง (/path หรือ https://…)',
    code: 'ชนิด',
    permanent: '301 ถาวร',
    temporary: '302 ชั่วคราว',
    add: 'เพิ่ม redirect',
    active: 'เปิดใช้',
    remove: 'ลบ',
    empty: 'ยังไม่มี redirect',
    importTitle: 'นำเข้าจาก CSV (PRO รายปี)',
    importHelp: 'หนึ่งบรรทัดต่อหนึ่งรายการ: ที่อยู่เดิม,ปลายทาง[,301|302]',
    importButton: 'นำเข้า',
    imported: (n: number) => `นำเข้าแล้ว ${n} รายการ`,
    importErrors: 'แถวที่นำเข้าไม่ได้:',
    line: (n: number) => `บรรทัด ${n}`,
    proOnly: 'Redirect ใช้ได้ในแพ็กเกจ PRO',
  },
  phonePreview: {
    button: 'ดูบนมือถือ',
    title: 'ดูตัวอย่างบนมือถือ',
    help: 'สแกน QR ด้วยมือถือภายใน 2 นาที ลิงก์ใช้ได้ครั้งเดียว และดูได้ 4 ชั่วโมง',
    qr: 'QR code ลิงก์ดูตัวอย่าง',
    copy: 'คัดลอกลิงก์',
  },
  domains: {
    title: 'โดเมนของคุณ',
    help: `ใช้ชื่อเว็บไซต์ของคุณเอง เช่น www.ร้านของคุณ.com แทน .${SITES_DOMAIN}`,
    upgrade: 'การใช้โดเมนของคุณเองมีในแพ็กเกจ PRO',
    current: (h: string) => `ผู้เข้าชมจะเห็นเว็บไซต์ที่ ${h}`,
    add: 'เพิ่มโดเมน',
    hostname: 'ชื่อโดเมน',
    hostnameHint: 'เช่น ร้านของคุณ.com หรือ www.ร้านของคุณ.co.th',
    mode: 'ต้องการใช้ชื่อแบบไหน',
    modes: {
      www: 'มี www (แนะนำ ตั้งค่าได้กับผู้ให้บริการ DNS ทุกเจ้า)',
      both: 'ทั้งแบบมีและไม่มี www (แบบไม่มี www จะพาไปที่ชื่อหลัก)',
      apex: 'ไม่มี www เท่านั้น (ผู้ให้บริการ DNS ต้องรองรับ CNAME flattening หรือ ALIAS)',
    },
    states: {
      unverified: 'รอยืนยันความเป็นเจ้าของโดเมน (ระเบียน TXT)',
      pending_dns: 'รอการตั้งค่า DNS',
      dns_verified: 'พบการตั้งค่า DNS แล้ว',
      ssl_provisioning: 'กำลังออกใบรับรอง SSL',
      active: 'ใช้งานได้แล้ว',
      suspended: 'ระงับชั่วคราว (แพ็กเกจ FREE)',
      removed: 'ลบแล้ว',
    },
    primary: 'ชื่อหลัก',
    makePrimary: 'ตั้งเป็นชื่อหลัก',
    dnsTitle: 'ตั้งค่า DNS ที่ผู้ให้บริการโดเมนของคุณ',
    dnsHelp:
      'เพิ่มระเบียนทั้งหมดในตาราง: TXT ใช้ยืนยันว่าคุณเป็นเจ้าของโดเมน ส่วน CNAME ชี้โดเมนมาที่เว็บไซต์ ระบบจะตรวจและออก SSL ให้อัตโนมัติ (มักเสร็จใน 10–30 นาที อาจนานถึง 24 ชั่วโมง)',
    type: 'Type',
    name: 'Name / Host',
    value: 'Target / Value',
    copy: (what: string) => `คัดลอก ${what}`,
    copied: 'คัดลอกแล้ว',
    apexNote:
      'ชื่อแบบไม่มี www ต้องใช้ผู้ให้บริการ DNS ที่รองรับ CNAME ที่ @ (CNAME flattening/ALIAS) หากไม่รองรับ ให้ใช้ “URL forwarding” ของผู้ให้บริการพาไปที่ชื่อแบบมี www แทน',
    check: 'ตรวจสอบตอนนี้',
    lastChecked: (d: string) => `ตรวจสอบล่าสุด ${d}`,
    activated: 'โดเมนพร้อมใช้งานแล้ว',
    lockedTitle: 'โดเมนของคุณเอง',
    lockedBullets: [
      'ใช้ชื่อธุรกิจเอง เช่น www.ร้านของคุณ.com',
      'HTTPS ให้อัตโนมัติ',
      'ใช้ได้ทั้งแบบมีและไม่มี www',
    ],
    republish: 'เผยแพร่อีกครั้ง',
    hsts: 'บังคับ HTTPS ถาวร (HSTS preload)',
    hstsOn: 'บังคับ HTTPS ถาวร (HSTS preload)',
    hstsOff: 'เลิกบังคับ HTTPS ถาวร',
    // u48
    manage: 'จัดการ',
    closeManage: 'ปิด',
    hstsHelp:
      'บังคับ HTTPS ถาวร: เบราว์เซอร์จะเข้าเว็บนี้แบบปลอดภัยเสมอ เหมาะเมื่อทุกโดเมนย่อยของคุณใช้ HTTPS แล้ว ส่วนใหญ่ไม่จำเป็นต้องเปิด',
    madePrimary: (host: string) => `ตั้ง ${host} เป็นชื่อหลักแล้ว`,
    hstsTurnedOff: 'เลิกบังคับ HTTPS ถาวรแล้ว (การถอนออกจากรายชื่อของเบราว์เซอร์อาจใช้เวลานาน)',
    limitReached: 'ใช้ได้สูงสุด 2 โดเมนต่อเว็บไซต์ ถ้าต้องการเปลี่ยน ให้ลบโดเมนเดิมก่อน',
    hstsWarn:
      'HSTS preload บังคับให้เบราว์เซอร์ใช้ HTTPS กับโดเมนนี้และทุก subdomain ถาวร การถอนออกจากรายชื่อของเบราว์เซอร์ใช้เวลานานมาก เปิดเฉพาะเมื่อทุก subdomain รองรับ HTTPS แล้ว',
    hstsConfirm: 'ฉันเข้าใจและต้องการเปิด',
    remove: 'ลบโดเมน',
    removeConfirm: 'ลบโดเมนนี้ออกจากเว็บไซต์? ผู้เข้าชมจะเข้าผ่านชื่อนี้ไม่ได้',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    ownerOnly: 'เฉพาะเจ้าของเว็บไซต์เท่านั้นที่จัดการโดเมนได้',
    platform: (d: string) => `ทีมงานจดโดเมนนี้ให้ หมดอายุ ${d}`,
  },
  billing: {
    title: 'แพ็กเกจและการชำระเงิน',
    current: 'แพ็กเกจปัจจุบัน',
    until: (d: string) => `ใช้ได้ถึง ${d}`,
    daysLeft: (n: number) => (n > 0 ? `เหลืออีก ${n} วัน` : 'ครบกำหนดแล้ว'),
    grace: (d: string) =>
      `แพ็กเกจครบกำหนดแล้ว ทุกฟีเจอร์ยังใช้ได้ถึง ${d} กรุณาต่ออายุเพื่อไม่ให้เว็บไซต์กลับเป็นแพ็กเกจ FREE`,
    canceled:
      'แพ็กเกจหมดอายุแล้ว เว็บไซต์ใช้สิทธิ์ FREE โดยข้อมูลทั้งหมดยังอยู่ครบ ต่ออายุได้ทุกเมื่อ',
    noAuto: 'ระบบไม่ตัดเงินอัตโนมัติ เราจะส่งอีเมลเตือนก่อนครบกำหนด 7 วันและ 1 วัน',
    stopReminders: 'ไม่ต้องเตือนต่ออายุ',
    resumeReminders: 'เปิดการเตือนต่ออายุ',
    plans: {
      pro_monthly: {
        name: 'PRO รายเดือน',
        period: '/เดือน',
        points: [
          '10 หน้า',
          'Pixel และ Conversions API',
          'ดูลูกค้าไม่จำกัด + CSV',
          'สถิติย้อนหลัง 1 ปี',
        ],
      },
      pro_annual: {
        name: 'PRO รายปี',
        period: '/ปี',
        points: ['25 หน้า', 'แจ้งเตือนผ่าน LINE OA', 'Google Tag Manager', 'คุ้มกว่ารายเดือน'],
      },
      vip_setup_3p: {
        name: 'VIP 1–3 หน้า',
        period: '',
        points: ['ทีมงานทำเว็บให้ 1–3 หน้า', 'แก้ไขดีไซน์ 2 รอบ', 'รวม PRO รายปี 1 ปี'],
      },
      vip_setup_8p: {
        name: 'VIP 4–8 หน้า',
        period: '',
        points: ['ทีมงานทำเว็บให้ 4–8 หน้า', 'แก้ไขดีไซน์ 2 รอบ', 'รวม PRO รายปี 1 ปี'],
      },
    },
    // u15 D5: manual mode (bank transfer → the team turns the plan on).
    manualTitle: 'อัปเกรดหรือต่ออายุ: โอนเงินแล้วแจ้งทีมงาน',
    manualHelp:
      'เลือกแพ็กเกจที่ต้องการ โอนเงินตามยอด แล้วส่งสลิปพร้อมชื่อเว็บไซต์ให้ทีมงานทาง LINE ทีมงานจะเปิดแพ็กเกจให้และแจ้งทางอีเมล',
    manualLine: 'ติดต่อทีมงานทาง LINE',
    manualSite: (name: string) => `ชื่อเว็บไซต์ที่ต้องแจ้ง: ${name}`,
    receiptsPending: 'ใบเสร็จจะพร้อมให้ดาวน์โหลดเร็ว ๆ นี้ เลขที่เอกสารด้านล่างใช้อ้างอิงได้ทันที',
    buyPromptPay: 'จ่ายด้วย PromptPay',
    buyCard: 'จ่ายด้วยบัตร',
    // u48: plans with the current one marked; actions named for what they do.
    sitePlans: 'แพ็กเกจเว็บไซต์',
    vipPlans: 'ให้ทีมงานทำเว็บให้ (VIP)',
    currentBadge: 'แพ็กเกจปัจจุบัน',
    freePlan: {
      name: 'ฟรี',
      points: ['2 หน้า', 'ที่อยู่ .edgepage.site', 'มีป้าย "สร้างด้วย EdgePage"'],
    },
    verbs: {
      upgrade: 'อัปเกรด',
      renew: 'ต่ออายุ',
      toAnnual: 'เปลี่ยนเป็นรายปี',
      toMonthly: 'เปลี่ยนเป็นรายเดือน',
      order: 'สั่งทำ',
    },
    cardWord: 'บัตร',
    buyWith: (verb: string, method: string) => `${verb}ด้วย ${method}`,
    renew: 'ต่ออายุ',
    qrTitle: 'สแกนเพื่อชำระเงิน',
    qrHelp: (m: number) => `สแกน QR ด้วยแอปธนาคารภายใน ${m} นาที ระบบจะยืนยันให้อัตโนมัติ`,
    qrAlt: 'QR PromptPay สำหรับชำระเงิน',
    waiting: 'รอการชำระเงิน…',
    simulate: 'จำลองการชำระเงิน (โหมดทดสอบ)',
    paid: 'ชำระเงินเรียบร้อย แพ็กเกจเปิดใช้งานแล้ว',
    republish: 'ชำระเงินเรียบร้อย แพ็กเกจใหม่เปิดใช้งานแล้ว',
    republishButton: 'เผยแพร่อีกครั้ง',
    failed: 'การชำระเงินไม่สำเร็จ กรุณาลองใหม่หรือใช้ช่องทางอื่น',
    expired: 'QR หมดอายุแล้ว กรุณาเริ่มใหม่',
    close: 'ปิด',
    ownerOnly: 'เฉพาะเจ้าของเว็บไซต์เท่านั้นที่ชำระเงินและแก้ข้อมูลใบเสร็จได้',
    invoices: 'ใบเสร็จรับเงิน',
    noInvoices: 'ยังไม่มีใบเสร็จ',
    invoiceNo: 'เลขที่',
    date: 'วันที่',
    amount: 'จำนวนเงิน (บาท)',
    status: 'สถานะ',
    print: 'ดู / พิมพ์ / บันทึก PDF',
    statuses: {
      paid: 'ชำระแล้ว',
      refunded: 'คืนเงินแล้ว',
      open: 'รอชำระ',
      void: 'ยกเลิก',
      draft: 'ร่าง',
    },
    profile: {
      title: 'ข้อมูลสำหรับออกใบเสร็จ',
      help: 'ใช้พิมพ์บนใบเสร็จครั้งถัดไป',
      name: 'ชื่อบุคคลหรือนิติบุคคล',
      taxId: 'เลขประจำตัวผู้เสียภาษี (13 หลัก)',
      taxIdInvalid: 'เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง',
      branch: 'รหัสสาขา (สำนักงานใหญ่ = 00000)',
      address: 'ที่อยู่',
      saved: 'บันทึกแล้ว',
    },
  },
  analytics: {
    title: 'สถิติเว็บไซต์',
    updated: (when: string) => `อัปเดตล่าสุด ${when} · ระบบอัปเดตทุกชั่วโมง`,
    notYet: 'ยังไม่มีข้อมูล ระบบจะเริ่มแสดงสถิติภายใน 1 ชั่วโมงหลังมีผู้เข้าชม',
    range: 'ช่วงเวลา',
    days: (n: number) => (n === 365 ? '1 ปี' : `${n} วัน`),
    pro: 'PRO',
    rangeLocked: 'ดูสถิติย้อนหลัง 30 วัน 90 วัน และ 1 ปี ได้ในแพ็กเกจ PRO',
    pageviews: 'การเข้าชม',
    visitors: 'ผู้เข้าชม',
    visitorsHelp: 'นับผู้เข้าชมไม่ซ้ำรายวันโดยไม่ใช้คุกกี้',
    lineClicks: 'คลิก LINE',
    phoneClicks: 'คลิกโทร',
    ctaClicks: 'คลิกปุ่มอื่น',
    leads: 'ลูกค้าติดต่อ (ฟอร์ม)',
    conversion: 'อัตราการเป็นลูกค้า',
    chart: 'กราฟการเข้าชมรายวัน',
    chartDesc: (from: string, to: string) =>
      `การเข้าชมและผู้เข้าชมรายวัน ตั้งแต่ ${from} ถึง ${to}`,
    showTable: 'แสดงเป็นตาราง',
    showChart: 'แสดงเป็นกราฟ',
    date: 'วันที่',
    topPages: 'หน้ายอดนิยม',
    topSources: 'ช่องทางที่เข้ามา',
    page: 'หน้า',
    source: 'ช่องทาง',
    contacts: 'คลิกติดต่อ',
    campaigns: 'แคมเปญโฆษณา (UTM)',
    campaignsLocked: 'ดูผลแคมเปญโฆษณาแยกตาม utm_source / utm_campaign ได้ในแพ็กเกจ PRO',
    medium: 'medium',
    campaign: 'campaign',
    empty: 'ยังไม่มีข้อมูลในช่วงนี้',
    export: 'ส่งออกรายงาน CSV',
    exportPro: 'การส่งออกรายงานใช้ได้ในแพ็กเกจ PRO',
    direct: 'เข้าตรง / ไม่ระบุ',
  },
  leads: {
    title: 'ลูกค้าที่ติดต่อเข้ามา',
    empty: 'ยังไม่มีลูกค้าติดต่อเข้ามา',
    emptyHelp: 'เมื่อมีคนกรอกฟอร์มบนเว็บไซต์ รายชื่อจะแสดงที่นี่ และแจ้งเตือนทางอีเมล',
    locked: (n: number) =>
      `มีลูกค้าติดต่อเข้ามาเพิ่ม ${n} รายการ — อัปเกรดเป็น PRO เพื่อเปิดดูชื่อและเบอร์โทรทันที`,
    lockedRow: 'ถูกล็อก — อัปเกรดเพื่อดู',
    shreddedRow: 'ข้อมูลหมดอายุตามระยะเวลาเก็บรักษาแล้ว',
    month: 'เดือน',
    status: 'สถานะ',
    allStatuses: 'ทุกสถานะ',
    phoneSearch: 'ค้นหาด้วยเบอร์โทร',
    search: 'ค้นหา',
    clear: 'ล้าง',
    more: 'โหลดเพิ่ม',
    detail: 'ดูรายละเอียด',
    receivedAt: 'วันที่ติดต่อ',
    name: 'ชื่อ',
    phone: 'เบอร์โทร',
    lineOrEmail: 'LINE / อีเมล',
    serviceOption: 'เรื่องที่ติดต่อ',
    message: 'ข้อความ',
    page: 'จากหน้า',
    source: 'ที่มา (UTM)',
    close: 'ปิด',
    statuses: {
      new: 'ใหม่',
      contacted: 'ติดต่อแล้ว',
      won: 'ปิดการขาย',
      lost: 'ไม่สำเร็จ',
      spam: 'สแปม',
    },
    delete: 'ลบข้อมูลทันที',
    deleteConfirm:
      'ลบข้อมูลของลูกค้ารายนี้ออกจากระบบทันที (สำเนาสำรองจะหมดอายุภายใน 30 วัน) ยืนยันหรือไม่?',
    deleted: (n: number) => `ลบข้อมูลแล้ว ${n} รายการ`,
    eraseByPhone: 'ลบข้อมูลตามเบอร์โทร (PDPA)',
    eraseHelp:
      'ใช้เมื่อลูกค้าขอให้ลบข้อมูล ระบบจะลบทุกรายการของเบอร์นี้ทันที (สำเนาสำรองจะหมดอายุภายใน 30 วัน)',
    confirm: 'ยืนยันการลบ',
    cancel: 'ยกเลิก',
    export: 'ส่งออก CSV',
    exporting: (n: number) => `กำลังส่งออก… ${n} รายการ`,
    exportPro: 'การส่งออก CSV ใช้ได้ในแพ็กเกจ PRO',
    ownerOnly: 'เฉพาะเจ้าของเว็บไซต์',
    retention: {
      title: 'ระยะเวลาเก็บข้อมูลลูกค้า',
      help: 'ข้อมูลที่เก่ากว่านี้จะถูกลบอัตโนมัติ',
      days: (n: number) => `${n} วัน`,
      saved: 'บันทึกแล้ว',
    },
  },
  integrations: {
    title: 'เชื่อมต่อและแจ้งเตือน',
    save: 'บันทึก',
    saved: 'บันทึกแล้ว',
    needsPublish: 'บันทึกแล้ว',
    pageHelp: 'เครื่องมือวัดผลโฆษณา และการแจ้งเตือนเมื่อมีลูกค้าติดต่อเข้ามา',
    // u47: grouped rows with a status; settings open on request.
    groupMeasure: 'วัดผลและโฆษณา',
    groupNotify: 'แจ้งเตือนเมื่อมีลูกค้าติดต่อ',
    configure: 'ตั้งค่า',
    close: 'ปิด',
    ownerOnlyShort: 'เฉพาะเจ้าของ',
    statusOff: 'ยังไม่ได้ตั้ง',
    statusPixels: (n: number) => `ตั้งแล้ว ${n} รายการ`,
    statusEmail: (n: number) => (n > 0 ? `ส่งถึงเจ้าของ + อีก ${n} คน` : 'ส่งถึงเจ้าของ'),
    statusConnected: 'เชื่อมต่อแล้ว',
    statusPaused: 'เชื่อมต่อแล้ว (ปิดแจ้งเตือนอยู่)',
    statusNotConnected: 'ยังไม่เชื่อมต่อ',
    removeTitle: 'ตัดการเชื่อมต่อ?',
    remove: 'ตัดการเชื่อมต่อ',
    test: 'ส่งทดสอบ',
    testOk: 'ส่งทดสอบสำเร็จ',
    testFailed: (code: string) => `ส่งทดสอบไม่สำเร็จ (${code})`,
    ownerOnly: 'เฉพาะเจ้าของเว็บไซต์เท่านั้นที่ตั้งค่าส่วนนี้ได้',
    upgradePro: 'ใช้ได้ในแพ็กเกจ PRO',
    upgradeAnnual: 'ใช้ได้ในแพ็กเกจ PRO รายปี',
    pixels: {
      summary: 'วัดผลโฆษณาจาก Meta, TikTok, Google และ LINE',
      title: 'Pixel โฆษณา',
      help: 'ใส่เฉพาะรหัส (ID) ไม่ต้องวางโค้ด ระบบจะโหลด Pixel หลังผู้เข้าชมกดยอมรับคุกกี้เท่านั้น',
      metaPixelId: 'Meta (Facebook) Pixel ID',
      tiktokPixelId: 'TikTok Pixel ID',
      ga4MeasurementId: 'Google Analytics 4 (G-…)',
      googleAdsId: 'Google Ads (AW-…)',
      lineTagId: 'LINE Tag ID',
    },
    gtm: {
      summary: 'ใช้เครื่องมืออื่นผ่าน Google Tag Manager',
      title: 'Google Tag Manager',
      help: 'ใส่รหัส Container (GTM-…) ระบบจะโหลดหลังผู้เข้าชมกดยอมรับคุกกี้เท่านั้น เหมือน Pixel',
      containerId: 'รหัส GTM Container',
      hosts: 'โดเมนของเครื่องมือที่โหลดผ่าน GTM (บรรทัดละ 1 เช่น https://static.hotjar.com)',
      warning:
        'แท็กแบบ "Custom HTML" ใน GTM จะไม่ทำงาน เพราะเว็บไซต์ปิดการรันโค้ดแทรกเพื่อความปลอดภัย ใช้แท็กแบบ Template แทน',
      confirm: 'ฉันเข้าใจและรับผิดชอบเครื่องมือที่เพิ่มผ่าน GTM รวมถึงการขอความยินยอมตาม PDPA',
    },
    email: {
      summary: 'ส่งอีเมลทันทีเมื่อมีลูกค้าฝากข้อมูล',
      title: 'อีเมลแจ้งเตือนเมื่อมีผู้ติดต่อ',
      help: 'ส่งถึงเจ้าของเว็บไซต์ทุกคนอยู่แล้ว เพิ่มผู้รับได้อีก 5 อีเมล (บรรทัดละ 1)',
      recipients: 'ผู้รับเพิ่มเติม',
      pending: (list: string) =>
        `รอยืนยันทางอีเมล: ${list} — ระบบส่งลิงก์ยืนยันไปแล้ว ผู้รับจะได้รับแจ้งเตือนหลังกดยืนยัน (บันทึกอีกครั้งเพื่อส่งลิงก์ใหม่)`,
    },
    line: {
      summary: 'ส่งข้อความเข้า LINE ของร้านเมื่อมีลูกค้าฝากข้อมูล',
      removeWhat: 'ระบบจะหยุดส่งแจ้งเตือนลูกค้าใหม่เข้า LINE ของร้าน (อีเมลแจ้งเตือนยังส่งตามปกติ)',
      title: 'แจ้งเตือนผ่าน LINE Official Account',
      help: 'ใช้ Channel Access Token จาก LINE Developers ของบัญชีคุณเอง และรหัสผู้รับ (User ID หรือ Group ID)',
      token: 'Channel Access Token',
      tokenKeep: 'เว้นว่างไว้เพื่อใช้ Token เดิม',
      toKeep: 'เว้นว่างไว้เพื่อใช้รหัสผู้รับเดิม',
      to: 'รหัสผู้รับ (U… หรือ C…)',
      enabled: 'เปิดการแจ้งเตือน',
      authFailed: 'ส่งแจ้งเตือนเข้า LINE ไม่สำเร็จ กรุณาตรวจสอบ Channel Access Token',
    },
    capi: {
      title: 'ส่งข้อมูลลูกค้าให้ Meta โดยตรง (Conversions API)',
      summary: 'ช่วยให้ Meta วัดผลโฆษณาได้แม่นขึ้น แม้เบราว์เซอร์บล็อกการติดตาม',
      removeWhat:
        'ระบบจะหยุดส่งข้อมูลลูกค้าที่ติดต่อเข้ามาให้ Meta โดยตรง รายงานโฆษณาอาจนับได้น้อยลง',
      help: 'ส่งเหตุการณ์ Lead ฝั่งเซิร์ฟเวอร์ (เฉพาะผู้เข้าชมที่ยอมรับคุกกี้) ใช้ event_id เดียวกับ Pixel เพื่อไม่ให้นับซ้ำ',
      pixelId: 'Pixel ID',
      token: 'Access Token',
      tokenKeep: 'เว้นว่างไว้เพื่อใช้ Token เดิม',
    },
  },
} as const;
